import * as AppConstants from 'app/AppConstants';
import keyBy from 'lodash/keyBy';

const initialState = () => ({
  limit: null,
  shares: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.SHARE__CARD_SHARES_LOADED: {
      const {limit, cards} = action.payload;
      const shares = keyBy(
        cards.map(card => ({
          ...card,
          id: String(card.id),
        })),
        'id'
      );

      return {
        limit,
        shares,
      };
    }
    default:
      return state;
  }
};
